import { Big } from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { TenantOrderLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtJob from '~/tenants/twt/model/TwtJob';
import TwtAiReelConfig from '~/tenants/twt/performable/ai-reel/TwtAiReelConfig';

export const TWT_AI_REEL_PRICE = 50;

export class TwtAiReelJob extends TwtJob<typeof TwtAiReelConfig> {
  get performable() {
    return TwtAiReelConfig;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.SOCIAL;
  }

  get short(): string {
    return 'AI REEL';
  }

  get media(): PersonaType {
    return PersonaType.OFFICE;
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtAiReelConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TWT_AI_REEL_PRICE),
        description: this.performable.name,
        discountable: true,
        id: 'ai_reel',
        taxable: true,
      },
    ];
  }
}
